export default __webpack_public_path__ + "static/media/mc_frontview.bab7c9af.svg";